import React from "react";
import HairColorStreaksLandingProgramHead from "./HairColorStreaksLandingProgramHead";
import HairColorStreaksLandingProgramMain from "./HairColorStreaksLandingProgramMain";
import "./HairColorStreaksLandingProgram.css"
const HairColorStreaksLandingProgram = () => {
  return (
    <div className="hairColorStreakLandingProgram">
      <HairColorStreaksLandingProgramHead />
      <HairColorStreaksLandingProgramMain />
    </div>
  );
};

export default HairColorStreaksLandingProgram;
